// LIB
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// STYLES
import { colors } from '../../Design_System/DesignSystem';

// COMPONENT
import logo from '../../assets/LOGOlemire.png';
import { Triangle } from 'react-loader-spinner';

const Intro = ({ isLightTheme }: { isLightTheme: boolean }) => {
  const [lodaingClassname, setLodaingClassname] = useState('mayfair');
  const [logoClassname, setLogoClassname] = useState('');

  useEffect(() => {
    setLogoClassname('fade-in');
    setTimeout(() => {
      setLodaingClassname('mayfair fade-out');
      setTimeout(() => {
        setLodaingClassname('mayfair none');
      }, 2000);
    }, 2000);
  }, []);

  return (
    <Loading isLightTheme={isLightTheme} className={lodaingClassname}>
      <LoaderItems>
        <Triangle
          height="200"
          width="200"
          color={colors.tan}
          ariaLabel="triangle-loading"
          visible={true}
        ></Triangle>
        <Logo
          src={logo}
          alt="logo of Tristan Lemire"
          className={logoClassname}
        />
      </LoaderItems>
    </Loading>
  );
};

const LoaderItems = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  position: absolute;
  top: 70%;
  left: 48%;
  transform: translate(-50%, -50%);
  max-width: 75px;
  height: auto;
  opacity: 0;
  transition: opacity 2s ease-in-out;

  &.fade-in {
    opacity: 1;
  }
`;

const Loading = styled.div<{
  isLightTheme: boolean;
}>`
  background-color: ${(props) =>
    props.isLightTheme ? colors.blue : colors.black};
  min-height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  opacity: 1;
  transition: opacity 1s ease-in-out;

  &.fade-out {
    opacity: 0;
  }

  &.none {
    z-index: -100;
    display: none;
  }
`;

export default Intro;
